import { createStyles, makeStyles } from '@material-ui/core/styles'
import React, { ReactElement } from 'react'
import { HeaderCellVariant } from '../types/HeaderCellVariant'

type CellType = 'date' | 'sum'

interface HeaderEndingProps {
  variant: HeaderCellVariant
  cellType: CellType
}

const useStyles = makeStyles(
  createStyles({
    root: {
      position: 'absolute',
      backgroundColor: ({ variant }: HeaderEndingProps) => {
        if (variant === 'salary') return '#E3EFF5'
        if (variant === 'revenue') return '#EDF8F7'
      },
      left: ({ variant }) => {
        if (variant === 'salary') return '100%'
        if (variant === 'revenue') return '0'
      },
      right: ({ variant }) => {
        if (variant === 'salary') return '-8px'
        if (variant === 'revenue') return '0'
      },
      top: ({ variant }) => {
        if (variant === 'salary') return '0'
        if (variant === 'revenue') return '100%'
      },
      bottom: ({ variant }) => {
        if (variant === 'salary') return '0'
        if (variant === 'revenue') return '-8px'
      },
      borderTopRightRadius: ({ variant, cellType }) => {
        if (variant === 'salary' && cellType === 'date') return 8
      },
      borderBottomRightRadius: ({ cellType }) => {
        if (cellType === 'sum') return 8
      },
      borderBottomLeftRadius: ({ variant, cellType }) => {
        if (variant === 'revenue' && cellType === 'date') return 8
      },
    },
  })
)

const HeaderEnding = ({ variant, cellType }: HeaderEndingProps): ReactElement => {
  const classes = useStyles({ variant, cellType })
  return <div className={classes.root} />
}

export default HeaderEnding
